// extracted by mini-css-extract-plugin
export var messageSideLeft = "_k8-1";
export var messageSideRight = "_k8-2";
export var orderLookupBubbleContainer = "_k8-0";
export var submitButton = "_k8-3";